// Feature/platform checks. Platform is only used to word hints, never to change behavior.
const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

// iPadOS 13+ reports itself as a Mac; touch support gives it away.
export const isIOS =
    /iPhone|iPad|iPod/i.test(ua) ||
    (typeof navigator !== 'undefined' && /Macintosh/.test(ua) && navigator.maxTouchPoints > 1);

export const isAndroid = /Android/i.test(ua);

export const canShare = () => typeof navigator !== 'undefined' && typeof navigator.share === 'function';

export const prefersReducedMotion = () =>
    typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export function storage(key, value) {
    try {
        if (value === undefined) return localStorage.getItem(key);
        if (value === null) localStorage.removeItem(key);
        else localStorage.setItem(key, value);
    } catch {
        return null;
    }
    return value;
}

// The dashboard records which card(s) belong to this browser's owner.
export function isOwnerOf(uuid) {
    try {
        const mine = JSON.parse(storage('hx:myCards') || '[]');
        return Array.isArray(mine) && mine.includes(uuid);
    } catch {
        return false;
    }
}

export function rememberOwnCard(uuid) {
    if (!uuid) return;
    try {
        const mine = new Set(JSON.parse(storage('hx:myCards') || '[]'));
        mine.add(uuid);
        storage('hx:myCards', JSON.stringify([...mine].slice(-5)));
    } catch {
        storage('hx:myCards', JSON.stringify([uuid]));
    }
}
